var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 187,
    viewBox: "0 0 212 187",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.112 187H47.8253C47.0086 187 46.3457 186.337 46.3457 185.518V184.202H165.591V185.518C165.59 186.336 164.929 187 164.112 187Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.64 141.831H81.4219V158.704C97.6544 154.999 114.129 151.925 130.64 149.073V141.831Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 158.704V176.173H130.64V149.073C114.129 151.926 97.6544 154.998 81.4219 158.704Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.955 185.003H47.1082C46.3115 185.003 46.1318 183.882 46.8885 183.632L81.4223 172.247H130.64L165.174 183.632C165.931 183.882 165.752 185.003 164.955 185.003Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.057 172.248H129.473",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 172.248H120.516",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 158.703L118.47 151.223",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.639 141.831V172.248",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4043 185.003H164.156",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 143.868V169.663",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.652 145.621H9.3484C4.73791 145.621 1 141.877 1 137.258V9.363C1 4.74445 4.73791 1 9.3484 1H202.652C207.262 1 211 4.74445 211 9.363V137.259C211 141.877 207.262 145.621 202.652 145.621Z",
    fill: "white",
    stroke: "#141414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211 31.7148V137.259C211 141.877 207.262 145.622 202.651 145.622H110.174",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 118.367V9.363C1 4.74445 4.73791 1 9.3484 1H202.652",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.948 53.4619C141.223 53.4619 135.963 55.4361 131.795 58.7345C131.795 58.6535 131.798 58.5735 131.798 58.4935C131.798 44.0608 120.118 32.3604 105.71 32.3604C91.3025 32.3604 79.6225 44.0608 79.6225 58.4935C79.6225 58.5745 79.6245 58.6545 79.6255 58.7345C75.4573 55.4361 70.1958 53.4619 64.4721 53.4619C50.9562 53.4619 40 64.4372 40 77.9769C40 91.5165 50.9562 102.492 64.4721 102.492C64.7896 102.492 65.1051 102.48 65.4196 102.468C65.7341 102.48 66.0496 102.492 66.3671 102.492H145.423C145.679 102.492 145.931 102.481 146.186 102.473C146.44 102.481 146.693 102.492 146.949 102.492C160.465 102.492 171.421 91.5165 171.421 77.9769C171.421 64.4372 160.464 53.4619 146.948 53.4619Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.948 53.4619C141.223 53.4619 135.963 55.4361 131.794 58.7345C131.795 58.6535 131.798 58.5735 131.798 58.4935C131.798 44.0608 120.118 32.3604 105.71 32.3604C91.3025 32.3604 79.6225 44.0608 79.6225 58.4935C79.6225 58.5745 79.6245 58.6545 79.6255 58.7345C75.4573 55.4361 70.1958 53.4619 64.4721 53.4619C50.9562 53.4619 40 64.4372 40 77.9769C40 91.5165 50.9562 102.492 64.4721 102.492C64.7896 102.492 65.1051 102.48 65.4196 102.468C65.7341 102.48 66.0496 102.492 66.3671 102.492",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.165 116.3C127.598 111.23 133.573 97.0223 128.511 84.5677C123.449 72.1131 109.267 66.1274 96.8339 71.1983C84.4011 76.2691 78.4258 90.4763 83.4878 102.931C88.5498 115.386 102.732 121.371 115.165 116.3Z",
    fill: "#D32F2F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.344 102.809L107.305 93.7538L116.344 84.6997C116.708 84.3357 116.708 83.7396 116.344 83.3756C115.981 83.0115 115.386 83.0115 115.023 83.3756L105.984 92.4297L96.946 83.3756C96.5826 83.0115 95.9875 83.0115 95.6241 83.3756C95.2607 83.7396 95.2607 84.3357 95.6241 84.6997L104.662 93.7538L95.6241 102.809C95.2607 103.173 95.2607 103.769 95.6241 104.133C95.9875 104.497 96.5826 104.497 96.946 104.133L105.985 95.079L115.024 104.133C115.387 104.497 115.982 104.497 116.345 104.133C116.708 103.769 116.708 103.173 116.344 102.809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc2);
export default __webpack_public_path__ + "static/media/pc2.40acf815df6c37578b360c8649cd6ff8.svg";
export { ForwardRef as ReactComponent };